export default "__VITE_ASSET__BJZ5Mjr1__"